module.exports = __webpack_public_path__ + "img/card3.db08821d.jpg";